import React from 'react';
import type { EstimatorColumn, TierPlan } from '../types/commission';
import { formatBps, formatPercent } from '../utils/format';
interface TierMinPanelProps {
  plan: TierPlan;
  actuals: EstimatorColumn;
  pacing: EstimatorColumn;
}
export function TierMinPanel({
  plan,
  actuals,
  pacing
}: TierMinPanelProps) {
  return <div className="rounded-xl border border-slate-200 bg-white shadow-sm" data-id="element-200" data-mp="29kqj7rszithz">
      <div className="border-b border-slate-200 px-4 py-3" data-id="element-201" data-mp="1ltcndbvmkfs9">
        <h3 className="text-sm font-semibold text-slate-900" data-id="element-202" data-mp="1lri402004vqa">Loan minimums</h3>
        <p className="mt-0.5 text-xs text-slate-500" data-id="element-203" data-mp="1hu3xii3ph21z">{plan.name}</p>
      </div>
      <ul className="divide-y divide-slate-100" data-id="element-204" data-mp="1vkfr6lfxv8v8">
        {plan.tiers.map(tier => {
        const isActual = tier.id === actuals.tier.id;
        const isProjected = tier.id === pacing.tier.id;
        return <li key={tier.id} className={`flex items-center justify-between gap-3 px-4 py-2.5 text-sm ${isProjected ? 'bg-brand-50/70' : ''}`} data-id="element-205" data-mp="131jxvrfrlcpa">
              <div data-id="element-206" data-mp="2fhjsspnbprqy">
                <p className="font-semibold text-slate-800" data-id="element-207" data-mp="2ki7hv5rzryij">
                  {tier.minUnits}
                  {tier.maxUnits === null ? '+' : `–${tier.maxUnits}`} loans
                </p>
                <p className="text-xs text-slate-500" data-id="element-208" data-mp="2u8ains5cugrf">
                  {formatBps(tier.basisPoints)} · {formatPercent(tier.overageSplit)} overage
                </p>
              </div>
              <div className="flex shrink-0 flex-col items-end gap-1" data-id="element-209" data-mp="1wmv31a857nwd">
                {isActual ? <span className="rounded-full bg-slate-800 px-2 py-0.5 text-[11px] font-semibold text-white" data-id="element-210" data-mp="21lg050s3lrgl">
                    Today
                  </span> : null}
                {isProjected ? <span className="rounded-full bg-brand-600 px-2 py-0.5 text-[11px] font-semibold text-white" data-id="element-211" data-mp="3hyeaz3d3eu34">
                    Projected
                  </span> : null}
              </div>
            </li>;
      })}
      </ul>
    </div>;
}